import { render, staticRenderFns } from "./CreateTask.vue?vue&type=template&id=97e5b1b6"
import script from "./CreateTask.vue?vue&type=script&lang=js"
export * from "./CreateTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ErrorBlock: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/ErrorBlock.vue').default,RichTextEditor: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/RichTextEditor.vue').default,AccountSelector: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/AccountSelector.vue').default,StyledSelect: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/StyledSelect.vue').default,AccountSelector: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/AccountSelector.vue').default,ClientCaseSelector: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/ClientCaseSelector.vue').default,ClientPlanSelect: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/ClientPlanSelect.vue').default,CustomField: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/CustomField.vue').default})
